// component.vue carries ONE stylesheet, style.css, NOT scoped — the original `<style>` block was
// not scoped (COMPONENT_LAYOUT.md recipe step 3: a single non-scoped block stays one non-scoped
// `style.css`, as App's does). Its rules are global: `.custom-dialog`, `.white-slider` and the
// datepicker's `.dp__theme_dark` variables. The datepicker's stock CSS is imported here, after the
// chart packages and IssuesGrid, where the old SFC imported it.
import { StackedHorizontalBarChart } from '@rdrive/plugin-chart-stacked-bar';
import { BaseDonutChart } from '@rdrive/plugin-chart-donut';
import { BaseTimeSeriesChart } from '@rdrive/plugin-chart-time-series';
import { BaseBoxPlotChart } from '@rdrive/plugin-chart-box-plot';
import { IssuesGrid } from '@rdrive/plugin-items-grid';
import '@vuepic/vue-datepicker/dist/main.css';
import setup from './setup.js';

export default {
  name: 'analysis-page',
  components: { StackedHorizontalBarChart, BaseDonutChart, BaseTimeSeriesChart, BaseBoxPlotChart, IssuesGrid },
  setup,
};
